import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';

const LanguageContext = createContext();

const isBrowser = typeof window !== 'undefined';

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    if (isBrowser) {
      return localStorage.getItem('siteLanguage') || 'en';
    }
    return 'en';
  });

  useEffect(() => {
    if (isBrowser) {
      localStorage.setItem('siteLanguage', language);
      document.documentElement.lang = language === 'ar' ? 'ar' : 'en';
      document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    }
  }, [language]);

  const setLanguage = useCallback((lang) => {
    setLanguageState(lang);
  }, []);

  const isRTL = language === 'ar';

  return (
    <LanguageContext.Provider value={{ language, setLanguage, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;
